import React from 'react';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';

/**
 * use googleMapsApiKey="" in local for dev purposes
 * @param {*} props 
 * @returns 
 */
function GoogleMapForSiteSupt(props) {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyD7rYafEbst83cps65IrvmUz61n33z4kIM"
    });

    let center = props.center;
    if (isLoaded) {
        const bounds = new window.google.maps.LatLngBounds();
        for (let latlng of props.latlngs)
            if (latlng && latlng.lat && latlng.lng)
                bounds.extend(new window.google.maps.LatLng(latlng.lat, latlng.lng));
        center = bounds.getCenter();
    }

    return isLoaded ?
        <GoogleMap
            mapContainerStyle={props.style}
            center={center}
            zoom={props.zoom}>
            <>
                {props.markers}
                {props.polygons}
            </>
        </GoogleMap> : "";

}

export default GoogleMapForSiteSupt;